import kebabCase from 'lodash/kebabCase';

export const INVOICE_TABLE_SORT_KEYS = {
  AMOUNT: 'grandTotal',
  DUE_DATE: 'dueDate',
  CREATED_DATE: 'createdDate',
  COMPANY_NAME: 'shipToDisplayName',
  ID: 'id',
};

export const INVOICE_TABLE_TAB_FILTERS = [
  { status: 'OPEN' },
  { status: 'PAID' },
  { status: 'UNCOLLECTIBLE' },
  { status: 'PAYMENT_DEFERRED' },
];

export const openAndPaidTabName = 'Open & Paid';
export const refundedTabName = 'Refunded';
export const openAndPaidTabNameKey = kebabCase(openAndPaidTabName);
export const refundedTabNameKey = kebabCase(refundedTabName);
